import React, { useState } from 'react';
import './../QuizResult/quizResult.css';
import { useTranslations, useStyles } from "examsbook-react-sdk/custom-hooks";
import { getQuizStatus } from "examsbook-react-sdk/common";
import { useSelector } from "react-redux";
import Modal from '@material-ui/core/Modal';
import ExclamationIcon from './../../../assets/images/finish-icon.PNG';

/**
 * Confirmation button.
 * @param props
 * @returns {*}
 * @constructor
 */
function ConfirmButton(props) {
    const { mode, text, clickOnYes, clickOnNo } = props;
    const t = useTranslations();
    const quiz = useSelector((state) => state.quiz);
    const { answered, marked, notAnswered, notAnsweredVisited } = getQuizStatus(quiz.questions);
    const [ showPopup, setShowPopup ] = useState(false);
    const classes = useStyles(styles)();

    const popupBody = (
        <div className={classes.paper}>
            <img src={ExclamationIcon} alt=""/>
            <h2>{t('Are_you_sure_you_want_to_finish')}</h2>
            <span>{t('FINISH_MODAL_DESC')}</span>
            <div className={classes.quizQuestionList}>
                <ul>
                    <li>
                        <span className={classes.attempted}/>
                        <p>{t('attempted')}</p>
                        <h4>{answered}</h4>
                    </li>
                    <li>
                        <span className={classes.notAttempted}/>
                        <p>{t('not_attempted')}</p>
                        <h4>{notAnswered}</h4>
                    </li>
                    <li>
                        <span className={classes.skipped}/>
                        <p>{t('SKIPPED')}</p>
                        <h4>{notAnsweredVisited}</h4>
                    </li>
                    <li>
                        <span className={classes.reviseLater}/>
                        <p>{t('REVISE_LATER')}</p>
                        <h4>{marked}</h4>
                    </li>

                </ul>
            </div>
            <div className={classes.quizButtonGroups}>
                <button onClick={onResume}>RESUME</button>
                <button className={classes.finishBtn} onClick={onSubmitConfirmation}>FINISH</button>
            </div>
        </div>
    );

    function submitBtnClick() {
        setShowPopup(!showPopup);
    }

    function onResume() {
        setShowPopup(!showPopup);
        clickOnNo();
    }

    function onSubmitConfirmation() {
        setShowPopup(!showPopup);
        clickOnYes();
    }

    function handleClose() {
        setShowPopup(false);
    }

    return (
        <>
            {
                showPopup && <Modal
                    open={showPopup}
                    onClose={handleClose}
                    className={classes.finishModal}
                >
                    {popupBody}
                </Modal>
            }
            <div className="confirm-button">
                <button disabled={mode === 'preview'} onClick={submitBtnClick}
                        className={showPopup ? classes.selectedBtn : ''}>{text}</button>
            </div>
        </>
    );

}

const styles = theme => ({
    // quiz screen css starts from here
    quizButtonGroups: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 'auto',
        '& button': {
            width: '250px',
            background: '#75757526',
            color: '#000',
            fontSize: 14,
            fontWeight: 'bold',
            padding: '16px 0',
            borderRadius: 4,
            outline: 'none',
            boxShadow: 'none',
            border: 0,
            letterSpacing: '1px',
            textTransform: 'uppercase',
            cursor: 'pointer'
        }
    },
    // selectedBtn: {
    //     background: '#5df2d6 !important'
    // },
    finishBtn: {
        background: '#00BFA5 !important',
        color: '#fff !important',
        marginTop: 10,
    },
    quizInstructionScreen: {
        display: 'none',
        '@media (max-width: 767px)': {
            position: 'fixed',
            top: 55,
            left: 0,
            padding: '30px 15px 20px',
            right: 0,
            height: 'calc(100vh - 55px)',
            background: '#fff',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto'
        }
    },
    quizTopicName: {
        '& h4': {
            margin: 0,
            color: '#000',
            fontSize: 20,
            fontWeight: 600,
            textAlign: 'center',
            whiteSpace: 'normal'
        },
        '& p': {
            color: '#000',
            margin: '20px 0 14px',
            fontSize: 15,
            fontWeight: 600,
            textAlign: 'center'
        },
        '& span': {
            fontSize: 36,
            fontWeight: 600,
            display: 'flex',
            justifyContent: 'center',
            textAlign: 'center',
            color: '#000'
        }
    },
    quizQuestionList: {
        marginBottom: 30,
        '& > ul': {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            '& > li': {
                display: 'flex !important',
                flexWrap: 'wrap',
                justifyContent: 'center',
                background: '#FFFFFF',
                boxShadow: '0px 1px 6px #00000021',
                borderRadius: 4,
                alignItems: 'center',
                color: '#000 !important',
                marginBottom: '4% !important',
                minWidth: '48%',
                maxWidth: '48%',
                width: '48%',
                padding: '10px 0px !important',
                boxSizing: 'border-box',
                lineHeight: 'inherit !important',
                '& h4': {
                    width: '100%',
                    margin: 0,
                    fontSize: 18,
                    textAlign: 'center',
                    paddingTop: 10,
                },
                '& span': {
                    width: 12,
                    height: 12,
                    display: 'flex',
                    borderRadius: '50%',
                    marginRight: 8,
                    position: 'relative',
                    top: 0
                },
                '& p': {
                    margin: 0,
                    fontSize: 14,
                    fontWeight: 'bold',
                    opacity: 0.5,
                    color: '#000'
                }
            }
        }
    },
    paper: {
        position: 'absolute',
        width: 450,
        backgroundColor: theme.palette.background.paper,
        border: '0px solid #000',
        boxShadow: 'none',
        boxSizing: 'border-box',
        padding: '20px',
        borderRadius: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& img': {
            width: 80,
        },
        '& > h4': {
            fontSize: 17,
            color: '#00BFA5',
            margin: 0,
            marginTop: 20,
            paddingBottom: 10,
        },
        '& > p': {
            fontSize: 13,
            color: '#00BFA5',
            margin: 0,
        },
        '& > h2': {
            textAlign: 'center',
            fontSize: 16,
            color: '#000',
            margin: 0,
            padding: '20px 0 20px'
        },
        '& > span': {
            color: '#000000',
            opacity: 0.4,
            textAlign: 'center',
            fontSize: 13,
            marginBottom: 30,
            fontWeight: 600
        },
        '@media (max-width: 767px)': {
            width: '95%',
        }
    },
    finishModal: {
        zIndex: '9999 !important',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    attempted: {
        background: '#27AE60',
    },
    reviseLater: {
        background: '#0B2F8A'
    },
    skipped: {
        background: '#FFC658'
    },
    notAttempted: {
        background: '#E1E2E1'
    },
});
export default ConfirmButton;
